import styles from "./ExternalLink.module.scss";
import { cond } from "../../../lib/html.js";

export default function ExternalLink({link, children, otherClasses}) {
    return (
		<a href={link} className={cond(otherClasses === undefined, styles.link, otherClasses)} target="_blank" rel="noopener noreferrer">
			{children}
		</a>
    );
}